var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoDialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 56.001 39.001",
    height: 512,
    viewBox: "0 0 56.001 39.001",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.031 25.999c0-9.925 8.075-18 18-18s18 8.075 18 18c0 1.35-.151 2.69-.449 4h3.449v-26h-42v26h3.449c-.299-1.31-.449-2.65-.449-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.031 35.998h-1.996c-.001 0-.003.001-.004.001h-19.416c-.464.617-1.198 1-1.991 1h-9.186c-.793 0-1.527-.383-1.992-1h-19.417-2.001l.001 3.001 56-.001z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.031,
    cy: 23.999,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28.031 9.999c-8.823 0-16 7.178-16 16 0 1.354.17 2.695.506 4h30.987c.336-1.305.506-2.646.506-4 .001-8.822-7.177-16-15.999-16zm-12 16c0 .553-.448 1-1 1s-1-.447-1-1c0-7.72 6.28-14 14-14 .552 0 1 .447 1 1s-.448 1-1 1c-6.617 0-12 5.383-12 12zm20.707-9.293-5.274 5.273c.351.595.567 1.28.567 2.019 0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4c.739 0 1.424.215 2.019.567l5.274-5.274c.391-.391 1.024-.391 1.414 0 .39.392.39 1.024 0 1.415z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.972 34.662c.06.168.228.337.466.337h9.186c.238 0 .406-.169.466-.337.142-.397.519-.663.941-.663h19v-31.934c0-1.14-.927-2.066-2.067-2.066h-45.867c-1.14 0-2.066.927-2.066 2.066v31.934h19c.422 0 .799.266.941.663zm-16.941-2.663c-.552 0-1-.447-1-1v-28c0-.553.448-1 1-1h44c.552 0 1 .447 1 1v28c0 .553-.448 1-1 1h-5.75-32.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDialIcon);
export default __webpack_public_path__ + "static/media/VideoDialIcon.c807e44a2ff153f815108acdab798f8a.svg";
export { ForwardRef as ReactComponent };